import {PLAY, PAUSE, STOP, OTHER_AUDIO, VIRTUAL_VIDEO} from "@/global/constant"
import pl from "element-ui/src/locale/lang/pl";
export default {
    namespaced: true,
    state: {
        // 播放状态
        status: STOP,
        audioInfo: {
            id: "",
            // 名称
            name: "",
            // 播放地址
            url: "",
            // 封面
            poster: "",
            // 音频类型
            type: "",
            // 音频专辑ID
            audioId: "",
            totalTime: 0
        },
        passTime: 0,
        playerEl: null,
        timer: null,
        onStop: null,
        autoPlay: false
    },
    mutations: {
        SET_AUDIO_INFO(state, data){
            state.audioInfo = data
        },
        CHANGE_STATUS(state, status){
            state.status = status
            // 开启计时
            if(status == PLAY){
                state.timer = setInterval(()=>{
                    if(state.passTime < state.audioInfo.totalTime){
                    // if(state.passTime < 5){
                        state.passTime ++
                    }else{
                        // 播放结束后回调
                        if(state.onStop){
                            state.onStop()
                        }else{
                            this.state.status = PAUSE;
                        }
                        clearInterval(state.timer)
                    }
                }, 1000)
            }else {
                clearInterval(state.timer)
            }
        },
        // 清空播放信息
        RESET_INFO(state){
            for (let key in state.audioInfo){
                state.audioInfo[key] = ""
            }
            clearInterval(state.timer)
            state.passTime = 0
            state.onStop = null
        },
        INITIAL_PLAYER(state, el){
            state.playerEl = el
        },
        INIT_ON_STOP(state, cal){
            if(cal){
                console.log("注册事件成功")
                state.onStop = cal
            }
        },
        SET_PASS_TIME(state, num){
            state.passTime = num;
        },
        SET_AUTO_PLAY(state, status){
            state.autoPlay = status
        }
    },
    actions: {
        // 开始播放
        playAsync(context, payload){
            context.commit("SET_AUDIO_INFO", payload.data)
            context.commit("CHANGE_STATUS", PLAY)
            context.commit("INIT_ON_STOP", payload.onStop)
            if(payload.cal){
                payload.cal()
            }
        },
        // 继续播放
        resumeAsync(context){
            context.commit("CHANGE_STATUS", PLAY)
        },
        // 暂停播放
        pauseAsync(context){
            console.log("into")
            context.commit("CHANGE_STATUS", PAUSE)
        },
        // 停止播放
        stopAsync(context){
            context.commit("CHANGE_STATUS", STOP)
            context.commit("RESET_INFO")
        },
        initialPlayerAsync(context, payload){
            context.commit("INITIAL_PLAYER", payload.el)
            payload.cal && payload.cal()
        },
        setPasstime(context, payload){
            context.commit("SET_PASS_TIME", payload)
        },
        setAutoPlay(context, playload){
            context.commit("SET_AUTO_PLAY", true)
        }
    }
}

